// https://apto-api-specs.netlify.app/private/stargateapi#operation/get_company_info
export default {
	website: 'https://acme.com',
	legal_name: 'dummy legal name',
	brand_name: 'dummy brand name',
	tax_id: '000111222',
	industry: 'payments',
	description: 'dummy_description',
};
